"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@rws-framework/client");
const component_1 = require("../pages/login/component");
const component_2 = require("../pages/home/component");
const component_3 = require("../layouts/default-layout/component");
const component_4 = require("@front/components/nav-bar/component");
const component_5 = require("@front/pages/company/list/component");
const component_6 = require("@front/pages/company/list-gate/component");
const component_7 = require("@front/pages/company/preview/component");
const component_8 = require("@front/pages/company/form/component");
const component_9 = require("@front/components/pagination/component");
const component_10 = require("@front/components/search-user/component");
const component_11 = require("@front/components/search-filter/component");
const form_parts_1 = require("@front/components/form-parts");
const component_12 = require("@front/components/crud-table/component");
const components_1 = require("@rws-framework/components");
const component_13 = require("@front/components/app-loader/component");
const component_14 = require("@front/components/v-select/component");
const component_15 = require("@front/components/chat/component");
const component_16 = require("@front/components/conversation-list/component");
const component_17 = require("@front/components/model-select/component");
const component_18 = require("@front/components/simple-model-select/component");
const component_19 = require("@front/components/acl-checkboxes/component");
const component_20 = require("@front/components/code-viewer/component");
const component_21 = require("@front/components/gen-image/component");
const component_22 = require("@front/components/file-card/component");
const component_23 = require("@front/components/payment-gateway/component");
const component_24 = require("@front/components/file-card-zoom/component");
const fast_components_1 = require("@microsoft/fast-components");
const component_25 = require("@front/components/knowledge-picker/component");
const component_26 = require("@front/components/knowledge-picker/knowledge-form-modal/component");
const component_27 = require("@front/pages/knowledge/form/component");
const component_28 = require("@front/pages/knowledge/preview/component");
const component_29 = require("@front/pages/user-group/form/form-content/component");
const component_30 = require("@front/pages/reports/cost/component");
const component_31 = require("@front/pages/reports/shared/component");
const component_32 = require("@front/components/language-switch/component");
const component_33 = require("@front/components/trainer/component");
const component_34 = require("@front/components/list-viewer/component");
const component_35 = require("@front/components/code-screen/component");
const component_36 = require("@front/components/google-drive-file-picker/component");
const component_37 = require("@front/components/chat-settings/component");
const component_38 = require("@front/components/voice-chat/component");
const component_39 = require("@front/pages/payment/list/component");
const component_40 = require("@front/pages/bot-test/list/component");
const component_41 = require("@front/pages/bot-test/form/component");
const component_42 = require("@front/pages/payment/preview/component");
const component_43 = require("@front/pages/password-reset/component");
const component_44 = require("@front/pages/password-reset-confirm/component");
const component_45 = require("@front/pages/avatar/list/component");
const component_46 = require("@front/pages/avatar/form/component");
const component_47 = require("@front/pages/avatar/preview/component");
const component_48 = require("@front/pages/conversation/list/component");
const component_49 = require("@front/pages/conversation/preview/component");
const component_50 = require("@front/pages/style/list/component");
const component_51 = require("@front/pages/style/form/component");
const component_52 = require("@front/pages/style/preview/component");
const component_53 = require("@front/components/star/component");
const component_54 = require("@front/components/ai-assist/component");
const component_55 = require("@front/components/ai-suggestions/component");
const component_56 = require("@front/components/autocomplete-triggers/component");
const component_57 = require("@front/pages/share/component");
const HtmlStripService_1 = __importDefault(require("@front/services/HtmlStripService"));
const component_58 = require("@front/components/share-window/component");
const component_59 = require("@front/components/icon-picker/component");
const component_60 = require("@front/components/accordion/component");
const component_61 = require("@front/pages/onboarding/user-list/component");
const component_62 = require("@front/pages/onboarding/list-gate/component");
const component_63 = require("@front/components/prompt-slots/component");
const component_64 = require("@front/components/shortcuts-info/component");
const component_65 = require("@front/components/keyboard-key/component");
const component_66 = require("@front/pages/onboarding/list/component");
const component_67 = require("@front/components/rws-tools/component");
const component_68 = require("@front/components/rag-settings/component");
const component_69 = require("@front/components/api-tool-setup/component");
const component_70 = require("@front/pages/settings/whatsapp/component");
const component_71 = require("@front/pages/settings/whatsapp/groups-list/component");
const component_72 = require("@front/pages/settings/social-media/component");
const component_73 = require("@front/pages/settings/social-media-plan/component");
const component_74 = __importDefault(require("@front/pages/whatsapp-group/component"));
const component_75 = __importDefault(require("@front/pages/whatsapp-group/form/component"));
const component_76 = __importDefault(require("@front/pages/whatsapp-dm-contact/component"));
const component_77 = require("@front/pages/whatsapp-group/gate/component");
const component_78 = require("@front/components/comms-stats-alerts/component");
const component_79 = require("@front/components/track-logs/component");
const component_80 = require("@front/components/comms-messages/component");
const component_81 = require("@front/components/activity-panels/component");
const component_82 = require("@front/pages/settings/social-media/children/dictionary-manager/component");
const component_83 = require("@front/components/tut-onboarding/component");
const component_84 = require("@front/pages/tutorial/category-list/component");
const component_85 = require("@front/components/ai-form/component");
const component_86 = require("@front/components/ai-form-editor/component");
exports.default = (parted) => {
    component_2.HomePage;
    component_1.LoginPage;
    component_3.DefaultLayout;
    (0, fast_components_1.provideFASTDesignSystem)().register((0, fast_components_1.fastCombobox)(), (0, fast_components_1.fastOption)());
    (0, form_parts_1.declareFormParts)(parted);
    // Initialize services
    HtmlStripService_1.default;
    component_54.AIAssistComponent;
    component_55.AISuggestionsComponent;
    component_56.AutocompleteTriggersComponent;
    component_24.FileCardZoom;
    component_53.StarComponent;
    component_4.NavBar;
    component_32.LangSwitcher;
    component_25.KnowledgePicker;
    component_26.KnowledgeFormModal;
    component_27.KnowledgeForm;
    component_28.KnowledgePreview;
    component_29.UserGroupFormContent;
    component_30.CostReports;
    component_17.ModelSelect;
    component_18.SimpleModelSelect;
    component_15.ChatComponent;
    component_16.ConversationListComponent;
    component_19.ACLCheckboxes;
    component_20.CodeViewerComponent;
    component_21.GenImage;
    component_22.FileCard;
    component_58.ShareWindow;
    component_14.VSelect;
    components_1.RWSTable;
    component_12.CrudTable;
    component_11.SearchFilter;
    component_5.CompanyList;
    component_6.CompanyListGate;
    component_7.CompanyPreview;
    component_8.CompanyForm;
    components_1.TableControls;
    component_33.LLMTrainer;
    component_34.ListViewerComponent;
    component_13.LoaderComponent;
    component_9.PaginationComponent;
    component_10.UserSearchComponent;
    component_61.OnboardingUserListComponent;
    component_62.OnboardingListGate;
    component_66.OnboardingList;
    component_35.CodeScreenComponent;
    component_36.GoogleDriveFilePicker;
    component_37.ChatSettingsComponent;
    component_38.VoiceChatComponent;
    component_45.AvatarList;
    component_46.AvatarForm;
    component_47.AvatarPreview;
    component_48.ConversationListPage;
    component_49.ConversationPreviewPage;
    component_50.StyleList;
    component_51.StyleForm;
    component_52.StylePreview;
    component_57.ShareConvo;
    component_59.IconPicker;
    component_60.AccordionComponent;
    component_30.CostReports;
    component_31.SharedReports;
    component_63.PromptSlotsComponent;
    component_64.ShortcutsInfoComponent;
    component_65.KeyboardKeyComponent;
    component_67.RWSToolsComponent;
    component_68.RagSettingsComponent;
    component_69.ApiToolSetup;
    component_23.PaymentGateway;
    component_43.PasswordResetPage;
    component_44.PasswordResetConfirmPage;
    component_39.PaymentList;
    component_42.PaymentPreview;
    component_40.BotTestListPage;
    component_41.BotTestFormPage;
    component_70.WhatsAppSettings;
    component_71.WaGroupList;
    component_72.SocialMediaSettings;
    component_73.SocialMediaPlanPage;
    component_74.default;
    component_75.default;
    component_76.default;
    component_77.CommsGate;
    component_78.CommsStatsAlerts;
    component_79.TrackLogs;
    component_80.CommsMessages;
    component_81.ActivityPanels;
    component_82.SmDictionaryManager;
    component_84.TutorialCategoryList;
    component_83.TutorialOnboardingWizard;
    component_85.AIFormComponent;
    component_86.AIFormEditorComponent;
    client_1.RWSClientInstance.defineAllComponents();
};
